export default "__VITE_ASSET__CU5NY5Nb__"